import { BitfPaginationApiRequestPart } from '@bitf/core/api-call-state/bitf-pagination-api-request-part.builder';

import { EApiCallStateNames, EApiRequestPartKeys } from '@enums';
import { IBitfApiCallState } from '@interfaces';
import { DefaultApiCallStateMapper } from './default-api-call-state.mapper';

export const apiCallStateConfig = [
  {
    apiCallStateName: EApiCallStateNames.DEMO,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
      sorting: [{ property: 'firstName', direction: 'ASC' }],
    },
    requestParts: [
      new BitfPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 2 },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
];
